import styled from '../../../../../theme'

const SidebarHeaderWrapper = styled.div`
  width: 310px;
  max-width: 310px;
  height: 56px;
  min-height: 56px;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  box-shadow: 0px 1px 4px 0 rgba(0, 0, 0, 0.25);
`

export default SidebarHeaderWrapper
